/*
 * Exports
 */
export { default } from './components/DigitalHoldsWorkflowView.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-holds-workflow-view/index.js